<ng-container *transloco="let t">
  <div class="hero bg-base-200 min-h-screen">
    @if (isLinkExpired$ | async) {
      <div>
        <div class="text-center">
          <p class="py-6">
            {{ t('verify-registration-link-has-expired') }}
          </p>
          <button (click)="goToRegistrationPage()" class="btn btn-primary">
            {{ t('verify-registration-go-to-registration-page-button') }}
          </button>
        </div>
      </div>
    } @else {
      <div class="text-center">
        <p class="py-6">
          {{ t('verify-registration-successfully-confirmed') }}
        </p>
        <button class="btn btn-primary" (click)="goHome()">
          {{ t('register-user-form-home-button') }}
        </button>
      </div>
    }
  </div>
</ng-container>
